"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gddFormTranslator = void 0;
exports.gddFormTranslator = {
    en: {
        title: "Title*",
        genre: "Genre",
        view: "Game View",
        platform: "Platform",
        saveButton: "Save",
        closeButton: "Close",
        titleRequired: "Game title is required",
        successMessage: "Success"
    },
    ru: {
        title: "Название*",
        genre: "Жанр",
        view: "Вид",
        platform: "Платформа",
        saveButton: "Сохранить",
        closeButton: "Закрыть",
        titleRequired: "Название не может быть пустым",
        successMessage: "Сохранено"
    }
};
